import { makeStyles } from '@material-ui/core';

export const useGridLayout = makeStyles(({ spacing }) => ({
  grid: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    gap: spacing(3)
  }
}));
